import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { EditTranscriptionSpeakersDialogComponent } from './edit-transcription-speakers-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FocusOnFirstInvalidFieldModule } from '@go-modules/directives/focus-on-first-invalid-field';
import { A11yModule } from '@angular/cdk/a11y';
import { GoDialogContentDirective } from '@go-modules/directives/go-dialog-content/go-dialog-content.directive';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormsModule,
		ReactiveFormsModule,
		FocusOnFirstInvalidFieldModule,
		A11yModule,
		GoDialogContentDirective
	],
	declarations: [
		EditTranscriptionSpeakersDialogComponent
	],
	exports: [
		EditTranscriptionSpeakersDialogComponent
	],
	providers: [
		TranslatePipe
	]
})
export class EditTranscriptionSpeakersDialogModule {}
